module.exports = __webpack_public_path__ + "static/img/sits_small.28556bd4.png";